/* Lite-YouTube activator for the product "product_videos" block.
   Replaces a thumbnail facade with the real YouTube iframe on click, so a product page
   with 11 videos ships 11 <img> instead of 11 full players. Delegated from the document
   so it survives Splide re-mounts and shopify:section:load in the editor. */
(function () {
  if (window.__azmLiteYT) return;
  window.__azmLiteYT = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-azm-lite-yt]');
    if (!btn) return;

    var id = btn.getAttribute('data-azm-lite-yt');
    if (!id) return;

    var iframe = document.createElement('iframe');
    /* autoplay=1 is safe here: the swap is user-initiated, which satisfies the
       browser autoplay policy. No mute needed — the visitor asked for this. */
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                 '?autoplay=1&playsinline=1&rel=0';
    iframe.title = btn.getAttribute('aria-label') || 'YouTube video player';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');

    btn.replaceWith(iframe);
    /* focus the player so keyboard users land inside it after activating */
    iframe.setAttribute('tabindex', '-1');
    iframe.focus({ preventScroll: true });
  }, false);
})();
